import { render, staticRenderFns } from "./ClientPlatform.vue?vue&type=template&id=14bf47ea&"
import script from "./ClientPlatform.vue?vue&type=script&lang=js&"
export * from "./ClientPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports